import {
  loadDeliveryCorp,
  cancelAftersales,
  transitTabs
} from '@/api/afterSales'

export const afterSalesMixin = {
  data () {
    return {
      aftersalesId: null,
      typeName: null,
      shipCorps: [],
      undoDialogVisible: false,
      expressDialogVisible: false
    }
  },
  created () {
    this.loadShippingCorps()
  },
  methods: {
    // 加载物流公司
    loadShippingCorps () {
      loadDeliveryCorp().then(res => {
        if (res.code === 0) {
          this.shipCorps = res.data
        }
      })
    },
    // 关闭弹窗
    handleCloseDialog () {
      this.undoDialogVisible = false
      this.expressDialogVisible = false
    },
    // 撤销申请
    handleUndo (aftersalesId, typeName) {
      this.aftersalesId = aftersalesId
      this.typeName = typeName
      this.undoDialogVisible = true
    },
    // 确认撤销
    handleCancerAftersales () {
      cancelAftersales(this.aftersalesId).then(res => {
        if (res.code === 0) {
          this.$message({
            message: `已取消${this.typeName}申请`,
            type: 'success'
          })
          this.reLoad()
        } else {
          this.$message.error(res.error)
        }
      })
    },
    // 填写快递单号
    handleExpress (aftersalesId) {
      this.aftersalesId = aftersalesId
      this.expressDialogVisible = true
    },
    // 提交快递单号
    handleTransitTabs (form) {
      const param = {
        afterSaleId: this.aftersalesId,
        deliveryCorpId: form.deliveryCorpId,
        trackingNo: form.trackingNo
      }
      transitTabs(param).then(res => {
        if (res.code === 0) {
          this.$message({
            message: '已提交快递单号',
            type: 'success'
          })
          this.reLoad()
        } else {
          this.$message.error(res.error)
        }
      })
    },
    // 查看进度
    handleStep (info) {
      this.$router.push({
        path: 'afterSalesApply',
        query: {
          aftersalesId: info.id || info.aftersalesId,
          uniteOrderNo: info.uniteOrderNo,
          orderStatus: info.orderStatus,
          typeIndex: this.typeIndex,
          moduleType: 'RETAIL'
        }
      })
    },
    reLoad () {
      this.undoDialogVisible = false
      this.expressDialogVisible = false
      if (this.loadList) {
        this.loadList()
      }
      if (this.loadAftersalesInfo) {
        this.loadAftersalesInfo()
      }
      if (this.loadAftersalesLogList) {
        this.loadAftersalesLogList()
      }
    }
  }
}
